(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@shraddhar/web/ripple'), require('@shraddhar/web/icon'), require('@material/ripple'), require('@material/chips'), require('@angular/forms'), require('@angular/common')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/chips', ['exports', '@angular/core', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@shraddhar/web/base', '@shraddhar/web/ripple', '@shraddhar/web/icon', '@material/ripple', '@material/chips', '@angular/forms', '@angular/common'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.chips = {}), global.ng.core, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.ng.web.base, global.ng.web.ripple, global.ng.web.icon, global.mdc.ripple, global.mdc.chips, global.ng.forms, global.ng.common));
}(this, (function (exports, core, coercion, platform, rxjs, operators, base, ripple, icon, ripple$1, chips, forms, common) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MdcChipPrimaryAction = /** @class */ (function () {
        function MdcChipPrimaryAction(elementRef) {
            this.elementRef = elementRef;
            this.role = 'button';
            this.tabIndex = null;
            this._root = this.elementRef.nativeElement;
        }
        MdcChipPrimaryAction.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-chip-primary-action, [mdcChipPrimaryAction]',
                        host: {
                            '[attr.role]': 'role',
                            '[attr.tabindex]': 'tabIndex',
                            'class': 'mdc-chip__action--primary'
                        }
                    },] }
        ];
        /** @nocollapse */
        MdcChipPrimaryAction.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcChipPrimaryAction.propDecorators = {
            role: [{ type: core.Input }],
            tabIndex: [{ type: core.Input }]
        };
        return MdcChipPrimaryAction;
    }());
    var MdcChipText = /** @class */ (function () {
        function MdcChipText() {
        }
        MdcChipText.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-chip-text, [mdcChipText]',
                        host: {
                            'class': 'mdc-chip__text'
                        }
                    },] }
        ];
        return MdcChipText;
    }());

    /**
     * Injection token used to provide the parent MdcChipSet component to MdcChip.
     */
    var MDC_CHIPSET_PARENT_COMPONENT = new core.InjectionToken('MDC_CHIPSET_PARENT_COMPONENT');
    var nextUniqueId = 0;
    var MdcChipCheckmark = /** @class */ (function () {
        function MdcChipCheckmark(elementRef) {
            this.elementRef = elementRef;
        }
        MdcChipCheckmark.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-chip-checkmark',
                        exportAs: 'mdcChipCheckmark',
                        host: {
                            'class': 'mdc-chip__checkmark'
                        },
                        template: "\n  <svg class=\"mdc-chip__checkmark-svg\"\n    viewBox=\"-2 -3 30 30\"\n    focusable=\"false\">\n    <path class=\"mdc-chip__checkmark-path\" fill=\"none\" stroke=\"black\" d=\"M1.73,12.91 8.1,19.28 22.79,4.59\"/>\n  </svg>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcChipCheckmark.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcChipCheckmark;
    }());
    var MdcChip = /** @class */ (function (_super) {
        __extends(MdcChip, _super);
        function MdcChip(_platform, _ngZone, _changeDetectorRef, _ripple, elementRef, _parent) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._ripple = _ripple;
            _this.elementRef = elementRef;
            _this._parent = _parent;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._id = "mdc-chip-" + nextUniqueId++;
            _this._filter = false;
            _this._choice = false;
            _this._input = false;
            _this._removable = true;
            _this._touch = false;
            _this._disableRipple = false;
            /** Emitted when the chip is interacted with. */
            _this.interactionEvent = new core.EventEmitter();
            /** Emitted when the chip is selected or deselected. */
            _this.selectionChange = new core.EventEmitter();
            /** Emitted as chip navigation event. */
            _this.navigationEvent = new core.EventEmitter();
            /** Emitted when trailing icon is interacted with. */
            _this.trailingIconInteraction = new core.EventEmitter();
            /** Emitted when a chip is to be removed. */
            _this.removalEvent = new core.EventEmitter();
            _this._root = _this.elementRef.nativeElement;
            _this._ripple = _this._createRipple();
            _this._ripple.init();
            return _this;
        }
        Object.defineProperty(MdcChip.prototype, "id", {
            /** The unique ID of the chip. */
            get: function () {
                return this._id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "leadingIcon", {
            get: function () {
                return this._icons.find(function (_) { return _.leading; });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "trailingIcon", {
            get: function () {
                return this._icons.find(function (_) { return _.trailing; });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "filter", {
            get: function () {
                return this._filter;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._filter) {
                    this._filter = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "choice", {
            get: function () {
                return this._choice;
            },
            set: function (value) {
                this._choice = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "input", {
            get: function () {
                return this._input;
            },
            set: function (value) {
                this._input = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "removable", {
            /** Determines whether or not the chip displays the remove styling and emits (removed) events. */
            get: function () {
                return this._removable;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._removable) {
                    this._removable = value;
                    this._foundation.setShouldRemoveOnTrailingIconClick(this._removable);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "touch", {
            get: function () {
                return this._touch;
            },
            set: function (value) {
                this._touch = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "disableRipple", {
            /** Whether the chip ripple is disabled. */
            get: function () {
                return this._disableRipple;
            },
            set: function (value) {
                this._disableRipple = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChip.prototype, "value", {
            /** The value of the chip. Defaults to the content inside `<mdc-chip>` tags. */
            get: function () {
                var _a, _b;
                return (_b = (_a = this._value) !== null && _a !== void 0 ? _a : this._root.textContent) !== null && _b !== void 0 ? _b : undefined;
            },
            set: function (value) {
                this._value = value;
            },
            enumerable: true,
            configurable: true
        });
        MdcChip.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                hasClass: function (className) { return _this._root.classList.contains(className); },
                addClassToLeadingIcon: function (className) { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = _this.leadingIcon) === null || _a === void 0 ? void 0 : _a.elementRef) === null || _b === void 0 ? void 0 : _b.nativeElement) === null || _c === void 0 ? void 0 : _c.classList) === null || _d === void 0 ? void 0 : _d.add(className); },
                removeClassFromLeadingIcon: function (className) { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = _this.leadingIcon) === null || _a === void 0 ? void 0 : _a.elementRef) === null || _b === void 0 ? void 0 : _b.nativeElement) === null || _c === void 0 ? void 0 : _c.classList) === null || _d === void 0 ? void 0 : _d.remove(className); },
                eventTargetHasClass: function (target, className) {
                    return (target && target.classList) ? target.classList.contains(className) : false;
                },
                focusPrimaryAction: function () { return _this._primaryAction._root.focus(); },
                focusTrailingAction: function () { var _a, _b, _c; return (_c = (_b = (_a = _this.trailingIcon) === null || _a === void 0 ? void 0 : _a.elementRef) === null || _b === void 0 ? void 0 : _b.nativeElement) === null || _c === void 0 ? void 0 : _c.focus(); },
                notifyInteraction: function () { return _this.interactionEvent.emit({
                    chipId: _this._id,
                    value: _this._value
                }); },
                notifySelection: function (selected, chipSetShouldIgnore) {
                    return _this.selectionChange.emit({
                        chipId: _this._id,
                        selected: selected,
                        value: _this._value,
                        shouldIgnore: chipSetShouldIgnore
                    });
                },
                notifyNavigation: function (key, source) {
                    return _this.navigationEvent.emit({
                        chipId: _this.id,
                        value: _this._value,
                        key: key,
                        source: source
                    });
                },
                notifyTrailingIconInteraction: function () { return _this.trailingIconInteraction.emit({
                    chipId: _this.id,
                    value: _this._value
                }); },
                notifyRemoval: function () { return _this.removalEvent.emit({
                    chipId: _this.id,
                    value: _this._value,
                    removedAnnouncement: null
                }); },
                getComputedStyleValue: function (propertyName) {
                    return _this._platform.isBrowser ? window.getComputedStyle(_this._root).getPropertyValue(propertyName) : '';
                },
                setStyleProperty: function (propertyName, value) {
                    return _this._root.style.setProperty(propertyName, value);
                },
                setTrailingActionAttr: function (attr, value) { var _a, _b, _c; return (_c = (_b = (_a = _this.trailingIcon) === null || _a === void 0 ? void 0 : _a.elementRef) === null || _b === void 0 ? void 0 : _b.nativeElement) === null || _c === void 0 ? void 0 : _c.setAttribute(attr, value); },
                hasLeadingIcon: function () { return !!_this.leadingIcon; },
                hasTrailingAction: function () { return !!_this.trailingIcon; },
                setPrimaryActionAttr: function (attr, value) { return _this._primaryAction._root.setAttribute(attr, value); },
                getRootBoundingClientRect: function () { return _this._root.getBoundingClientRect(); },
                getCheckmarkBoundingClientRect: function () { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = _this._checkmark) === null || _a === void 0 ? void 0 : _a.elementRef) === null || _b === void 0 ? void 0 : _b.nativeElement) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) !== null && _d !== void 0 ? _d : null; },
                isRTL: function () { return typeof window !== 'undefined' ?
                    window.getComputedStyle(_this._root).getPropertyValue('direction') === 'rtl' : false; },
                getAttribute: function (attr) { return _this._root.getAttribute(attr); }
            };
            return new chips.MDCChipFoundation(adapter);
        };
        MdcChip.prototype.ngAfterViewInit = function () {
            this._foundation.init();
            this._setVariantFromChipSet();
            this._loadListeners();
        };
        MdcChip.prototype.ngOnDestroy = function () {
            var _a, _b;
            this._destroyed.next();
            this._destroyed.complete();
            (_a = this._ripple) === null || _a === void 0 ? void 0 : _a.destroy();
            (_b = this._foundation) === null || _b === void 0 ? void 0 : _b.destroy();
        };
        MdcChip.prototype.setSelectedFromChipSet = function (selected, shouldNotifyClients) {
            this._foundation.setSelectedFromChipSet(selected, shouldNotifyClients);
        };
        /** Allows for programmatic focusing of the chip. */
        MdcChip.prototype.focus = function () {
            this.focusPrimaryAction();
        };
        MdcChip.prototype.focusPrimaryAction = function () {
            this._foundation.focusPrimaryAction();
        };
        MdcChip.prototype.focusTrailingAction = function () {
            this._foundation.focusTrailingAction();
        };
        MdcChip.prototype.removeFocus = function () {
            this._foundation.removeFocus();
        };
        /**
         * Allows for programmatic removal of the chip.
         * Informs any listeners of the removal request. Does not remove the chip from the DOM.
         */
        MdcChip.prototype.remove = function () {
            if (this.removable) {
                this._foundation.beginExit();
            }
        };
        MdcChip.prototype._handleInteraction = function (evt) {
            this._foundation.handleInteraction(evt);
        };
        MdcChip.prototype._onKeydown = function (evt) {
            this._foundation.handleInteraction(evt);
            this._foundation.handleKeydown(evt);
        };
        MdcChip.prototype._onFocusIn = function (evt) {
            this._foundation.handleFocusIn(evt);
        };
        MdcChip.prototype._onFocusOut = function (evt) {
            this._foundation.handleFocusOut(evt);
        };
        MdcChip.prototype._handleTrailingIconInteraction = function (evt) {
            this._foundation.handleTrailingIconInteraction(evt);
        };
        MdcChip.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, ripple.MdcRipple.createAdapter(this)), { computeBoundingRect: function () { return _this._foundation.getDimensions(); }, isSurfaceDisabled: function () { return _this._disableRipple; } });
            return new ripple.MdcRipple(this.elementRef, new ripple$1.MDCRippleFoundation(adapter));
        };
        MdcChip.prototype._setVariantFromChipSet = function () {
            if (this._parent) {
                this.input = this._parent.input;
                this.filter = this._parent.filter;
                this.choice = this._parent.choice;
                this._changeDetectorRef.detectChanges();
            }
        };
        MdcChip.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._root, 'transitionend')
                    .pipe(operators.takeUntil(_this._destroyed))
                    .subscribe(function (evt) { return _this._ngZone.run(function () { return _this._foundation.handleTransitionEnd(evt); }); });
            });
        };
        MdcChip.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-chip',
                        exportAs: 'mdcChip',
                        host: {
                            '[id]': 'id',
                            'role': 'row',
                            'class': 'mdc-chip',
                            '[class.mdc-chip--selected]': 'selected',
                            '[class.mdc-chip--touch]': 'touch',
                            '(click)': '_handleInteraction($event)',
                            '(keydown)': '_onKeydown($event)',
                            '(focusin)': '_onFocusIn($event)',
                            '(focusout)': '_onFocusOut($event)',
                        },
                        template: "<div class=\"mdc-chip__ripple\"></div>\r\n<ng-content select=\"mdc-chip-icon[leading]\"></ng-content>\r\n<mdc-chip-checkmark *ngIf=\"filter\"></mdc-chip-checkmark>\r\n<span role=\"gridcell\">\r\n  <mdc-chip-primary-action>\r\n    <div class=\"mdc-chip__touch\" *ngIf=\"touch\"></div>\r\n    <mdc-chip-text *ngIf=\"label\">{{label}}</mdc-chip-text>\r\n    <ng-content></ng-content>\r\n  </mdc-chip-primary-action>\r\n</span>\r\n<span role=\"gridcell\" *ngIf=\"!!trailingIcon\">\r\n  <ng-content select=\"mdc-chip-icon[trailing]\"></ng-content>\r\n</span>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        providers: [ripple.MdcRipple]
                    }] }
        ];
        /** @nocollapse */
        MdcChip.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.NgZone },
            { type: core.ChangeDetectorRef },
            { type: ripple.MdcRipple },
            { type: core.ElementRef },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MDC_CHIPSET_PARENT_COMPONENT,] }] }
        ]; };
        MdcChip.propDecorators = {
            selected: [{ type: core.Input }],
            label: [{ type: core.Input }],
            filter: [{ type: core.Input }],
            choice: [{ type: core.Input }],
            input: [{ type: core.Input }],
            removable: [{ type: core.Input }],
            touch: [{ type: core.Input }],
            disableRipple: [{ type: core.Input }],
            value: [{ type: core.Input }],
            interactionEvent: [{ type: core.Output }],
            selectionChange: [{ type: core.Output }],
            navigationEvent: [{ type: core.Output }],
            trailingIconInteraction: [{ type: core.Output }],
            removalEvent: [{ type: core.Output }],
            _checkmark: [{ type: core.ContentChild, args: [MdcChipCheckmark, { static: false },] }],
            _icons: [{ type: core.ContentChildren, args: [core.forwardRef(function () { return MdcChipIcon; }), { descendants: true },] }],
            _primaryAction: [{ type: core.ViewChild, args: [MdcChipPrimaryAction, { static: true },] }],
            _chipText: [{ type: core.ViewChild, args: [MdcChipText, { static: true },] }]
        };
        return MdcChip;
    }(base.MDCComponent));
    var MdcChipIcon = /** @class */ (function (_super) {
        __extends(MdcChipIcon, _super);
        function MdcChipIcon(_parentChip, elementRef, iconRegistry, ariaHidden, location) {
            var _this = _super.call(this, elementRef, iconRegistry, ariaHidden, location) || this;
            _this._parentChip = _parentChip;
            _this._leading = false;
            _this._trailing = false;
            return _this;
        }
        Object.defineProperty(MdcChipIcon.prototype, "leading", {
            get: function () {
                return this._leading;
            },
            set: function (value) {
                this._leading = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChipIcon.prototype, "trailing", {
            get: function () {
                return this._trailing;
            },
            set: function (value) {
                this._trailing = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcChipIcon.prototype._onIconInteraction = function (evt) {
            if (this.trailing) {
                this._parentChip._handleTrailingIconInteraction(evt);
            }
        };
        MdcChipIcon.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-chip-icon, [mdcChipIcon]',
                        exportAs: 'mdcChipIcon',
                        host: {
                            'class': 'mdc-chip__icon',
                            '[attr.role]': 'trailing ? "button" : "img"',
                            '[attr.tabindex]': 'trailing ? 1 : -1',
                            '[class.mdc-chip__icon--leading]': 'leading',
                            '[class.mdc-chip__icon--trailing]': 'trailing',
                            '[class.mdc-chip__trailing-action]': 'trailing',
                            '(click)': '_onIconInteraction($event)',
                            '(keydown)': '_onIconInteraction($event)'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcChipIcon.ctorParameters = function () { return [
            { type: MdcChip },
            { type: core.ElementRef },
            { type: icon.MdcIconRegistry },
            { type: String, decorators: [{ type: core.Attribute, args: ['aria-hidden',] }] },
            { type: undefined, decorators: [{ type: core.Inject, args: [icon.MDC_ICON_LOCATION,] }] }
        ]; };
        MdcChipIcon.propDecorators = {
            leading: [{ type: core.Input }],
            trailing: [{ type: core.Input }]
        };
        return MdcChipIcon;
    }(icon.MdcIcon));

    /**
     * Provider Expression that allows mdc-chip-set to register as a ControlValueAccessor. This
     * allows it to support [(ngModel)] and ngControl.
     */
    var MDC_CHIP_SET_CONTROL_VALUE_ACCESSOR = {
        provide: forms.NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MdcChipSet; }),
        multi: true
    };
    var MdcChipSetChange = /** @class */ (function () {
        function MdcChipSetChange(source, value) {
            this.source = source;
            this.value = value;
        }
        return MdcChipSetChange;
    }());
    var MdcChipSet = /** @class */ (function (_super) {
        __extends(MdcChipSet, _super);
        function MdcChipSet(_changeDetectorRef, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._choice = false;
            _this._filter = false;
            _this._input = false;
            /**
             * A function to compare the option values with the selected values. The first argument
             * is a value from an option. The second is a value from the selection. A boolean
             * should be returned.
             */
            _this._compareWith = function (o1, o2) { return o1 === o2; };
            _this.change = new core.EventEmitter();
            _this.interaction = new core.EventEmitter();
            /** Function when touched */
            _this._onTouched = function () { };
            /** Function when changed */
            _this._onChange = function () { };
            /** Subscription to selection events in chips. */
            _this._chipSelectionSubscription = null;
            /** Subscription to removal changes. */
            _this._chipRemovalSubscription = null;
            /** Subscription to interaction events in chips. */
            _this._chipInteractionSubscription = null;
            /** Subscription to navigation events. */
            _this._navigationSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcChipSet.prototype, "choice", {
            /**
            * Indicates that the chips in the set are choice chips, which allow a single selection from a set of options.
            */
            get: function () {
                return this._choice;
            },
            set: function (value) {
                this._choice = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChipSet.prototype, "filter", {
            /**
            * Indicates that the chips in the set are filter chips, which allow multiple selection from a set of options.
            */
            get: function () {
                return this._filter;
            },
            set: function (value) {
                this._filter = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChipSet.prototype, "input", {
            /**
            * Indicates that the chips in the set are input chips, which enable user input by converting text into chips.
            */
            get: function () {
                return this._input;
            },
            set: function (value) {
                this._input = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChipSet.prototype, "value", {
            get: function () {
                return this._value;
            },
            set: function (value) {
                this._value = value;
                this.writeValue(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChipSet.prototype, "chipSelections", {
            /** Combined stream of all of the chip selection events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.chips.map(function (chip) { return chip.selectionChange; })));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChipSet.prototype, "chipInteractions", {
            /** Combined stream of all of the chip interaction events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.chips.map(function (chip) { return chip.interactionEvent; })));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChipSet.prototype, "chipRemovalChanges", {
            /** Combined stream of all of the chip removal events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.chips.map(function (chip) { return chip.removalEvent; })));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcChipSet.prototype, "chipNavigations", {
            /** Combined stream of all of the chip navigation events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.chips.map(function (chip) { return chip.navigationEvent; })));
            },
            enumerable: true,
            configurable: true
        });
        MdcChipSet.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                focusChipPrimaryActionAtIndex: function (index) { return _this.chips.toArray()[index].focusPrimaryAction(); },
                focusChipTrailingActionAtIndex: function (index) { return _this.chips.toArray()[index].focusTrailingAction(); },
                getChipListCount: function () { return _this.chips.length; },
                getIndexOfChipById: function (chipId) { return _this._findChipIndex(chipId); },
                removeChipAtIndex: function (index) {
                    if (index >= 0 && index < _this.chips.length) {
                        _this.chips.toArray()[index].destroy();
                        _this.chips.toArray()[index].remove();
                        _this.chips.toArray().splice(index, 1);
                    }
                },
                removeFocusFromChipAtIndex: function (index) { return _this.chips.toArray()[index].removeFocus(); },
                selectChipAtIndex: function (index, selected, shouldNotifyClients) {
                    if (index >= 0 && index < _this.chips.length) {
                        _this.chips.toArray()[index].setSelectedFromChipSet(selected, shouldNotifyClients);
                    }
                },
                announceMessage: function () { },
                isRTL: function () { return typeof window !== 'undefined' ?
                    window.getComputedStyle(_this._getHostElement()).getPropertyValue('direction') === 'rtl' : false; }
            };
            return new chips.MDCChipSetFoundation(adapter);
        };
        MdcChipSet.prototype.ngAfterContentInit = function () {
            var _this = this;
            // When chips change, re-subscribe
            this.chips.changes.pipe(operators.startWith(null), operators.takeUntil(this._destroyed))
                .subscribe(function () {
                _this._resetChipSet();
                if (_this.chips.length >= 0) {
                    _this._initializeSelection();
                }
            });
        };
        MdcChipSet.prototype.ngOnDestroy = function () {
            var _a, _b;
            this._destroyed.next();
            this._destroyed.complete();
            this._dropSubscriptions();
            (_a = this._chipRemovalSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            (_b = this._foundation) === null || _b === void 0 ? void 0 : _b.destroy();
        };
        // Implemented as part of ControlValueAccessor.
        MdcChipSet.prototype.writeValue = function (value) {
            this.selectByValue(value, true);
        };
        // Implemented as part of ControlValueAccessor.
        MdcChipSet.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        // Implemented as part of ControlValueAccessor.
        MdcChipSet.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        MdcChipSet.prototype.getSelectedChipIds = function () {
            return this._foundation.getSelectedChipIds();
        };
        MdcChipSet.prototype.select = function (chipId) {
            this._foundation.select(chipId);
        };
        MdcChipSet.prototype.selectByValue = function (value, shouldIgnore) {
            var _this = this;
            if (shouldIgnore === void 0) { shouldIgnore = true; }
            if (!this.chips) {
                return;
            }
            if (Array.isArray(value)) {
                value.forEach(function (currentValue) { return _this._selectValue(currentValue, shouldIgnore); });
            }
            else {
                this._selectValue(value, shouldIgnore);
            }
            this._value = value;
        };
        /**
         * Finds and selects the chip based on its value.
         * @returns Chip that has the corresponding value.
         */
        MdcChipSet.prototype._selectValue = function (value, shouldIgnore) {
            var _this = this;
            if (shouldIgnore === void 0) { shouldIgnore = true; }
            var correspondingChip = this.chips.find(function (chip) {
                return chip.value != null && _this._compareWith(chip.value, value);
            });
            if (correspondingChip) {
                if (this.choice) {
                    this.select(correspondingChip.id);
                }
                else {
                    correspondingChip.setSelectedFromChipSet(true, shouldIgnore);
                }
            }
            return correspondingChip;
        };
        MdcChipSet.prototype._initializeSelection = function () {
            var _this = this;
            // Defer setting the value in order to avoid the "Expression
            // has changed after it was checked" errors from Angular.
            Promise.resolve().then(function () {
                if (_this._value) {
                    _this.selectByValue(_this._value, false);
                }
            });
        };
        MdcChipSet.prototype._propagateChanges = function (evt) {
            this._value = evt.value;
            this.change.emit(new MdcChipSetChange(this, evt));
            this._onChange(this._value);
            this._changeDetectorRef.markForCheck();
        };
        MdcChipSet.prototype._findChipIndex = function (chipId) {
            return this.chips.toArray().findIndex(function (_) { return _.id === chipId; });
        };
        MdcChipSet.prototype._resetChipSet = function () {
            this._dropSubscriptions();
            this._listenToChipEvents();
        };
        MdcChipSet.prototype._dropSubscriptions = function () {
            var _a, _b, _c, _d;
            (_a = this._chipSelectionSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            (_b = this._chipInteractionSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
            (_c = this._chipRemovalSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
            (_d = this._navigationSubscription) === null || _d === void 0 ? void 0 : _d.unsubscribe();
        };
        /** Listens to selected events on each chip. */
        MdcChipSet.prototype._listenToChipEvents = function () {
            var _this = this;
            this._chipSelectionSubscription = this.chipSelections
                .subscribe(function (event) {
                _this._foundation.handleChipSelection(event);
                _this._propagateChanges(event);
            });
            this._chipInteractionSubscription = this.chipInteractions
                .subscribe(function (event) {
                _this._foundation.handleChipInteraction(event);
                _this.interaction.emit(event);
            });
            this._chipRemovalSubscription = this.chipRemovalChanges
                .subscribe(function (event) {
                return _this._foundation.handleChipRemoval(event);
            });
            this._navigationSubscription = this.chipNavigations
                .subscribe(function (event) {
                return _this._foundation.handleChipNavigation(event);
            });
        };
        /** Retrieves the DOM element of the component host. */
        MdcChipSet.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcChipSet.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-chip-set',
                        exportAs: 'mdcChipSet',
                        host: {
                            'role': 'grid',
                            'class': 'mdc-chip-set',
                            '[class.mdc-chip-set--choice]': 'choice',
                            '[class.mdc-chip-set--filter]': 'filter',
                            '[class.mdc-chip-set--input]': 'input'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        providers: [
                            MDC_CHIP_SET_CONTROL_VALUE_ACCESSOR,
                            { provide: MDC_CHIPSET_PARENT_COMPONENT, useExisting: MdcChipSet }
                        ]
                    }] }
        ];
        /** @nocollapse */
        MdcChipSet.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef }
        ]; };
        MdcChipSet.propDecorators = {
            choice: [{ type: core.Input }],
            filter: [{ type: core.Input }],
            input: [{ type: core.Input }],
            value: [{ type: core.Input }],
            change: [{ type: core.Output }],
            interaction: [{ type: core.Output }],
            chips: [{ type: core.ContentChildren, args: [MdcChip, { descendants: true },] }]
        };
        return MdcChipSet;
    }(base.MDCComponent));

    var CHIP_DECLARATIONS = [
        MdcChip,
        MdcChipCheckmark,
        MdcChipIcon,
        MdcChipPrimaryAction,
        MdcChipSet,
        MdcChipText
    ];
    var MdcChipsModule = /** @class */ (function () {
        function MdcChipsModule() {
        }
        MdcChipsModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule, icon.MdcIconModule],
                        exports: CHIP_DECLARATIONS,
                        declarations: CHIP_DECLARATIONS
                    },] }
        ];
        return MdcChipsModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_CHIPSET_PARENT_COMPONENT = MDC_CHIPSET_PARENT_COMPONENT;
    exports.MDC_CHIP_SET_CONTROL_VALUE_ACCESSOR = MDC_CHIP_SET_CONTROL_VALUE_ACCESSOR;
    exports.MdcChip = MdcChip;
    exports.MdcChipCheckmark = MdcChipCheckmark;
    exports.MdcChipIcon = MdcChipIcon;
    exports.MdcChipPrimaryAction = MdcChipPrimaryAction;
    exports.MdcChipSet = MdcChipSet;
    exports.MdcChipSetChange = MdcChipSetChange;
    exports.MdcChipText = MdcChipText;
    exports.MdcChipsModule = MdcChipsModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-chips.umd.js.map
